export default __webpack_public_path__ + "static/House-Demolition-ef23bf435f8f6225909cf0b4b390c6ff.jpg";